import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import storage from 'redux-persist/lib/storage';
import { createTransform, persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import rootReducer from './reducers';

const resetLoggingOutOnRehydrate = createTransform(
  (inboundState) => inboundState,
  (outboundState) => ({ ...outboundState, isLoggingOut: false }),
  { whitelist: ['common'] }
);

const persistConfig = {
  key: 'root',
  storage,
  transforms: [resetLoggingOutOnRehydrate],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
)

export const persistor = persistStore(store);

// export default createStore(
//   rootReducer,
//   composeWithDevTools(applyMiddleware(thunk))
// );
